type PermissionsSettingsRouteOrganizationLike = {
  isMaster?: boolean | null
}

export const TEAM_PERMISSIONS_SETTINGS_PATH = '/team/settings?tab=permissions'
export const ORGANIZATION_PERMISSIONS_SETTINGS_PATH =
  '/organization/settings?tab=permissions'

export const resolvePermissionsSettingsPath = ({
  selectedOrganization,
}: {
  selectedOrganization?: PermissionsSettingsRouteOrganizationLike | null
}): string | undefined => {
  if (selectedOrganization?.isMaster === true) {
    return ORGANIZATION_PERMISSIONS_SETTINGS_PATH
  }

  if (selectedOrganization?.isMaster === false) {
    return TEAM_PERMISSIONS_SETTINGS_PATH
  }

  return undefined
}
